import * as jwt from "jsonwebtoken";
import * as api from "~/api";
import { KEY_NAME } from "~/configs";
import { CLINIC } from "~/utils/urlApi";

export const getAllClinic = (baseUrl, data) => {
  data.sign = jwt.sign(data, KEY_NAME);
  return api.postHttpRequestAsync(`${baseUrl}${CLINIC.GET_ALL}`, data);
};

export const getDetailByDateClinic = (baseUrl, data) => {
  data.sign = jwt.sign(data, KEY_NAME);
  return api.postHttpRequestAsync(
    `${baseUrl}${CLINIC.GET_DETAIL_BY_DATE}`,
    data
  );
};

export const getPDFClinic = (baseUrl, data) => {
  data.sign = jwt.sign(data, KEY_NAME);
  return api.postHttpRequestAsync(`${baseUrl}${CLINIC.GET_PDF}`, data);
};
